module.exports = __webpack_public_path__ + "static/img/route_bg.6e51ab90.png";